module.exports = __webpack_public_path__ + "images/emoji/o.1d94f993e488c7e7493f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/o.png
// module id = QxNk
// module chunks = 14